module.exports = __webpack_public_path__ + "static/media/volcán.dd0dc542.png";